import { render } from "./AuthorConfirmPage.vue?vue&type=template&id=1a9ddf49&scoped=true&ts=true"
import script from "./AuthorConfirmPage.vue?vue&type=script&lang=ts"
export * from "./AuthorConfirmPage.vue?vue&type=script&lang=ts"

import "./AuthorConfirmPage.vue?vue&type=style&index=0&id=1a9ddf49&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9ddf49"]])

export default __exports__